module.exports = __webpack_public_path__ + "img/dpa.a154bd3a.svg";